import { render, staticRenderFns } from "./gestionCodigosCrear.vue?vue&type=template&id=49bef400"
import script from "./gestionCodigosCrear.vue?vue&type=script&lang=js"
export * from "./gestionCodigosCrear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports